// removed by extract-text-webpack-plugin
module.exports = {"Pax":"_21AW7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Payment/Confirmation/Confirmation.scss
// module id = 942
// module chunks = 0